<template>
    <p class="company-information-form-advice typographies-paragraph-small-bold">
        <CompassIcon icon="comment-fill" :size="CompassEnums.IconSize.SMALL" />
        {{ $t.__('CompanyInformation.form.advice') }}
    </p>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { Translator } from 'types/injects/translator.type';

const $t = inject('$t') as Translator;
</script>

<style lang="scss" scoped>
.company-information-form-advice {
    color: var(--colors-common-text-subtle-default);
    display: flex;
    gap: var(--spacing-0);
    margin: 0;

    &:deep(.compass-icon) {
        color: var(--colors-common-icon-informative);
        flex-shrink: 0;
    }
}
</style>
